import React, { useState, useEffect, useRef } from 'react';
import { IMenuItemData } from '@msdyn365-commerce-modules/navigation-menu';

interface CelliIMenuItemData extends IMenuItemData {
    Slug?: any;
    Children?: any;
    Name?: any;
    Url?: any;
    RecordId?: any;
}

interface SubHeaderNavigationMenuProps {
    menuItemData: CelliIMenuItemData[];
    serviceCategoryRecordId: number | undefined;
}

const SubHeaderNavigationMenu: React.FC<SubHeaderNavigationMenuProps> = ({ menuItemData, serviceCategoryRecordId }) => {
    const [openCategory, setOpenCategory] = useState<number | null>(null);
    const [hoveredItems, setHoveredItems] = useState<CelliIMenuItemData[][]>([]);
    const hoverTimeouts = useRef(new Map<string, NodeJS.Timeout>());
    const containerRef = useRef<HTMLDivElement>(null);

    const toggleCategory = (categoryId: number) => {
        setOpenCategory(prevCategory => {
            const newCategory = prevCategory === categoryId ? null : categoryId;
            if (newCategory !== prevCategory) {
                setHoveredItems([]);
            }
            return newCategory;
        });
    };

    const openOnHover = (categoryId: number) => {
        setOpenCategory(prevCategory => {
            if (prevCategory !== categoryId) {
                setHoveredItems([]);
            }
            return categoryId;
        });
    };

    // @ts-ignore
    const openSubMenu = (subItem: CelliIMenuItemData, depth: number) => {
        setHoveredItems(prev => {
            const newHoveredItems = [...prev.slice(0, depth - 2), subItem.Children?.$mobx?.values || []];
            return newHoveredItems;
        });
    };

    const closeOnClickOutside = (event: MouseEvent) => {
        if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
            setOpenCategory(null);
            setHoveredItems([]);
        }
    };

    const handleMouseEnter = (subItem: CelliIMenuItemData, depth: number) => {
        hoverTimeouts.current.forEach(timeout => clearTimeout(timeout));
        hoverTimeouts.current.clear();

        const timeoutId = setTimeout(() => {
            setHoveredItems(prev => {
                const newHoveredItems = [...prev.slice(0, depth - 2), subItem.Children?.$mobx?.values || []];
                return newHoveredItems;
            });
        }, 100);

        hoverTimeouts.current.set(subItem['Slug'], timeoutId);
    };

    const handleMouseLeave = () => {
        setHoveredItems([]);
        setOpenCategory(null);
        hoverTimeouts.current.forEach(timeout => clearTimeout(timeout));
        hoverTimeouts.current.clear();
    };

    useEffect(() => {
        document.addEventListener('mousedown', closeOnClickOutside);
        return () => {
            document.removeEventListener('mousedown', closeOnClickOutside);
        };
    }, []);

    return (
        <div className='ms-sub-header__menu-container__left-buttons__navigation-menu' ref={containerRef} onMouseLeave={handleMouseLeave}>
            {menuItemData.map(
                (categoryData: CelliIMenuItemData) =>
                    categoryData['RecordId'] !== serviceCategoryRecordId && (
                        <div key={categoryData['Slug']} className='category'>
                            <div
                                className='ms-sub-header__menu-container__left-buttons__navigation-menu__categories'
                                onClick={() => categoryData['Slug'] !== undefined && toggleCategory(categoryData['Slug'])}
                                onMouseEnter={() => categoryData['Slug'] !== undefined && openOnHover(categoryData['Slug'])}
                            >
                                <a href={categoryData['Url']}>{categoryData['Name']}</a>
                            </div>
                            {openCategory === categoryData['Slug'] && categoryData['Children'] && categoryData['Children'].length > 0 && (
                                <ul className='ms-sub-header__menu-container__left-buttons__navigation-menu__links'>
                                    <div style={{ display: 'flex' }}>
                                        {[categoryData['Children'].$mobx?.values, ...hoveredItems].map((items, index) => (
                                            <div key={index} style={{ paddingLeft: index > 0 ? '20px' : '' }}>
                                                {items?.map((subItem: CelliIMenuItemData) => (
                                                    <li key={subItem['Slug']} onMouseEnter={() => handleMouseEnter(subItem, index + 2)}>
                                                        <a href={subItem['Url']}>{subItem['Name']}</a>
                                                    </li>
                                                ))}
                                            </div>
                                        ))}
                                    </div>
                                </ul>
                            )}
                        </div>
                    )
            )}
        </div>
    );
};

export default SubHeaderNavigationMenu;
